import {
  AbandonedCarts,
  Achievements,
  AdditionalInfo,
  ArticleCategories,
  Articles,
  AuthRequests,
  Banners,
  BonusDistributions,
  BonusPoints,
  BonusPointsDebts,
  BonusPointsTillypad,
  Certificates,
  Clients,
  DeliveryAreas,
  DeliverySetting,
  EventCategories,
  Events,
  Faq,
  IntervalCustomSettings,
  LiveLoveWork,
  Login,
  ManualOrders,
  Onboarding,
  Orders,
  OrdersHoldPayment,
  PartnerDiscounts,
  PaymentAccounts,
  Permissions,
  PointCategories,
  PointProducts,
  Points,
  ProductCategories,
  ProductConstructor,
  Products,
  ProductSets,
  ProductsGroups,
  ProductVideo,
  PromoCodes,
  Promotion,
  PromotionsCategories,
  Push,
  Receipts,
  Rewards,
  Roles,
  Segments,
  Stories,
  StoriesV2,
  StuckOrders,
  SupportChannels,
  SystemSettings,
  UserStatuses,
  UserStatusGroups,
  ViewZones,
  VirtualProductCategories} from "src/pages";

export const UNAUTH_PATHS = [
  {
    path: "/dashboard/auth",
    isDefault: true,
    component: Login
  },
  {
    path: "/healthcheck",
    isDefault: false,
    component: () => <div></div>
  },
  {
    path: "/view-zones",
    isDefault: false,
    component: ViewZones
  },
];

export const UNAUTH_MAIN_PAGE = UNAUTH_PATHS.find((path) => path.isDefault)?.path ?? "";

export const PRIVATE_PATHS = [
  {
    path: "/dashboard/achievements",
    isDefault: true,
    component: Achievements
  },
  {
    path: "/dashboard/clients",
    isDefault: true,
    component: Clients
  },
  {
    path: "/dashboard/banners",
    isDefault: true,
    component: Banners
  },
  {
    path: "/dashboard/additional-info",
    isDefault: false,
    component: AdditionalInfo
  },
  {
    path: "/dashboard/promo-codes",
    isDefault: false,
    component: PromoCodes
  },
  {
    path: "/dashboard/partner-discounts",
    isDefault: false,
    component: PartnerDiscounts
  },
  {
    path: "/dashboard/live-love-work",
    isDefault: false,
    component: LiveLoveWork
  },
  {
    path: "/dashboard/stories",
    isDefault: false,
    component: Stories
  },
  {
    path: "/dashboard/stories-v2",
    isDefault: false,
    component: StoriesV2
  },
  {
    path: "/dashboard/certificates",
    isDefault: false,
    component: Certificates
  },
  {
    path: "/dashboard/articles",
    isDefault: false,
    component: Articles
  },
  {
    path: "/dashboard/article-categories",
    isDefault: false,
    component: ArticleCategories
  },
  {
    path: "/dashboard/promotions",
    isDefault: false,
    component: Promotion
  },
  {
    path: "/dashboard/promotion-categories",
    isDefault: false,
    component: PromotionsCategories
  },
  {
    path: "/dashboard/events",
    isDefault: false,
    component: Events
  },
  {
    path: "/dashboard/event-categories",
    isDefault: false,
    component: EventCategories
  },
  {
    path: "/dashboard/products",
    isDefault: false,
    component: Products
  },
  {
    path: "/dashboard/products-video",
    isDefault: false,
    component: ProductVideo
  },
  {
    path: "/dashboard/product-categories",
    isDefault: false,
    component: ProductCategories
  },
  {
    path: "/dashboard/products-groups",
    isDefault: false,
    component: ProductsGroups
  },
  {
    path: "/dashboard/points",
    isDefault: false,
    component: Points
  },
  {
    path: "/dashboard/push",
    isDefault: false,
    component: Push
  },
  {
    path: "/dashboard/payment-accounts",
    isDefault: false,
    component: PaymentAccounts
  },
  {
    path: "/dashboard/delivery-setting",
    isDefault: false,
    component: DeliverySetting
  },
  {
    path: "/dashboard/delivery-areas",
    isDefault: false,
    component: DeliveryAreas
  },
  {
    path: "/dashboard/orders",
    isDefault: false,
    component: Orders
  },
  {
    path: "/dashboard/order-hold-payment",
    isDefault: false,
    component: OrdersHoldPayment
  },
  {
    path: "/dashboard/stuck-orders",
    isDefault: false,
    component: StuckOrders
  },
  {
    path: "/dashboard/points-product",
    isDefault: false,
    component: PointProducts
  },
  {
    path: "/dashboard/product-constructor",
    isDefault: false,
    component: ProductConstructor
  },
  {
    path: "/dashboard/onboarding",
    isDefault: false,
    component: Onboarding
  },
  {
    path: "/dashboard/faq",
    isDefault: false,
    component: Faq
  },
  {
    path: "/dashboard/user-status-groups",
    isDefault: false,
    component: UserStatusGroups
  },
  {
    path: "/dashboard/user-statuses",
    isDefault: false,
    component: UserStatuses
  },
  {
    path: "/dashboard/rewards",
    isDefault: false,
    component: Rewards
  },
  {
    path: "/dashboard/virtual-product-categories",
    isDefault: false,
    component: VirtualProductCategories
  },
  {
    path: "/dashboard/product-sets",
    isDefault: false,
    component: ProductSets
  },
  {
    path: "/dashboard/manual-order",
    isDefault: false,
    component: ManualOrders
  },
  {
    path: "/dashboard/intervals-custom-settings",
    isDefault: false,
    component: IntervalCustomSettings
  },
  {
    path: "/dashboard/permissions",
    isDefault: false,
    component: Permissions
  },
  {
    path: "/dashboard/roles",
    isDefault: false,
    component: Roles
  },
  {
    path: "/dashboard/system-settings",
    isDefault: false,
    component: SystemSettings
  },
  {
    path: "/dashboard/receipts",
    isDefault: false,
    component: Receipts
  },
  {
    path: "/dashboard/bonus-distributions",
    isDefault: false,
    component: BonusDistributions
  },
  {
    path: "/dashboard/auth-requests",
    isDefault: false,
    component: AuthRequests
  },
  {
    path: "/dashboard/bonus-points",
    isDefault: false,
    component: BonusPoints
  },
  {
    path: "/dashboard/bonus-points-tillypad",
    isDefault: false,
    component: BonusPointsTillypad
  },
  {
    path: "/dashboard/bonus-points-debts",
    isDefault: false,
    component: BonusPointsDebts
  },
  {
    path: "/dashboard/segments",
    isDefault: false,
    component: Segments
  },
  {
    path: "/dashboard/support-channels",
    isDefault: false,
    component: SupportChannels
  },
  {
    path: "/dashboard/abandoned-carts",
    isDefault: false,
    component: AbandonedCarts
  },
  {
    path: "/dashboard/point-categories",
    isDefault: false,
    component: PointCategories
  },
];

export const BASIC_PRIVATE_PATH = PRIVATE_PATHS.find((path) => path.isDefault)?.path ?? "";
